/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { PureComponent } from 'react';
import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import H5 from 'UIComponents/elements/headings/H5';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { FLINT } from 'HubStyleTokens/colors';
import UIFileButton from 'UIComponents/button/UIFileButton';
import I18n from 'I18n';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { FONT_STYLE_OPTIONS } from '../../../constants/FontsConstants';
import { FONT_FILE_TYPES, ModalPages } from 'ContentData/constants/fonts';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE } from 'file-manager-components/constants/fileAccess';
import { getUploadCustomFontFileRequestStatus, getCreateCustomFontRequestStatus, getEditCustomFontRequestStatus, getCustomFontFetchStatus, getCustomFontToEdit, getUploadedCustomFontFilesByName, getUploadedCustomFontFilesById, getFetchCustomFontFileRequestStatus } from 'ContentData/selectors/fonts';
import * as FontsActions from 'ContentData/actions/Fonts';
import * as RequestStatus from 'ContentUtils/constants/RequestStatus';
import text from 'I18n/utils/unescapedText';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.font.modals.upload.edit.${key}`;
const mapStateToProps = state => {
  return {
    uploadFileRequestStatus: getUploadCustomFontFileRequestStatus(state),
    uploadedFileManagerFilesByName: getUploadedCustomFontFilesByName(state),
    uploadedFileManagerFilesById: getUploadedCustomFontFilesById(state),
    createCustomFontRequestStatus: getCreateCustomFontRequestStatus(state),
    editCustomFontRequestStatus: getEditCustomFontRequestStatus(state),
    customFontFetchStatus: getCustomFontFetchStatus(state),
    fontToEdit: getCustomFontToEdit(state),
    fetchCustomFontFileRequestStatus: getFetchCustomFontFileRequestStatus(state)
  };
};
const mapDispatchToProps = {
  uploadFile: FontsActions.uploadCustomFontFile,
  fetchFile: FontsActions.fetchCustomFontFile,
  createCustomFont: FontsActions.createCustomFont,
  editCustomFont: FontsActions.editCustomFont,
  fetchCustomFont: FontsActions.fetchCustomFont,
  clearUpdateRequestStatuses: FontsActions.clearUpdateRequestStatuses
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class EditCustomFont extends PureComponent {
  constructor(props) {
    super(props);
    this.unpackageBrandingCustomFontData = font => {
      const {
        variants
      } = font;
      const fontFiles = [];
      const fontStyles = [];
      variants.forEach(variant => {
        variant.files.forEach(file => {
          const parsedFileName = decodeURI(this.getFileNameFromUrl(file.file));
          fontFiles.push(Object.assign({}, file, {
            fileName: parsedFileName
          }));
          fontStyles.push({
            fileName: parsedFileName,
            style: variant.name
          });
        });
      });

      //sort variants thinnest to boldest
      const style_order = Object.keys(this.fontStyleMap);
      fontStyles.sort((a, b) => style_order.indexOf(a.style) - style_order.indexOf(b.style));
      return {
        fontName: font.name,
        fontFiles,
        fontStyles
      };
    };
    this.getFileNameFromUrl = url => {
      return url.substring(url.lastIndexOf('/') + 1);
    };
    this.onNameChange = e => {
      const {
        handleUpdate
      } = this.props;
      const name = e.target.value;
      handleUpdate({
        fontName: name
      });
    };
    this.onStylesChange = (index, style) => {
      const {
        handleUpdate,
        fontStyles = [],
        fontId
      } = this.props;
      const newStyles = [...fontStyles];
      newStyles.splice(index, 1, {
        fileName: newStyles[index].fileName,
        style
      });
      handleUpdate({
        fontStyles: newStyles,
        fontEdited: !!fontId
      });
    };
    this.addEmptyStyle = () => {
      const {
        handleUpdate,
        fontStyles = []
      } = this.props;
      handleUpdate({
        fontStyles: [...fontStyles, {
          fontName: undefined,
          style: undefined
        }]
      });
    };
    this.onSaveFont = () => {
      const {
        fontId,
        fontFilesUploaded,
        createCustomFont,
        editCustomFont,
        uploadFileRequestStatus,
        usageTracker
      } = this.props;
      this.setState({
        fontIsSaving: true,
        fontSaveFailed: false
      });

      //only upload files not already uploaded this session, can happen on resave after failed font save
      const filesToUpload = fontFilesUploaded && fontFilesUploaded.filter(file => uploadFileRequestStatus[file.name] !== RequestStatus.SUCCEEDED && file);
      if (filesToUpload && Object.keys(filesToUpload).length) {
        this.uploadFontFiles(filesToUpload);
      } else {
        if (fontId) {
          editCustomFont(this.packageBrandingCustomFontData());
          usageTracker.track('ContentComponentsInteraction', {
            action: 'custom-fonts-edit-font'
          });
        } else {
          createCustomFont(this.packageBrandingCustomFontData());
          usageTracker.track('ContentComponentsInteraction', {
            action: 'custom-fonts-create-font'
          });
        }
      }
    };
    this.uploadFontFiles = filesToUpload => {
      const {
        uploadFile
      } = this.props;

      // kicks off font files upload, componentDidUpdate handles next steps
      filesToUpload.forEach(file => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('options', JSON.stringify({
          access: VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE
        }));
        uploadFile(formData, file.name);
      });
    };
    this.renderFile = (style, index) => {
      const {
        fontFiles,
        removeFile,
        addFiles
      } = this.props;
      const {
        fileName
      } = style;
      const file = fontFiles && fontFiles.find(_file => _file.fileName === fileName);
      if (fileName) {
        return /*#__PURE__*/_jsx(UIFileAttachment, {
          fileName: fileName,
          fileInfo: file && file.fileSize && I18n.formatSize(file.fileSize),
          size: "small",
          closeable: true,
          onCloseClick: () => removeFile(index, fileName, false),
          "data-selenium": `font-upload-files-uploaded:${fileName}`
        });
      }
      return /*#__PURE__*/_jsxs(UIFileButton, {
        onChange: e => addFiles(e.target.files, index),
        accept: FONT_FILE_TYPES,
        "data-selenium": "font-upload-edit-file-upload-button",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "upload"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('uploadAFile')
        })]
      });
    };
    this.renderPrimaryButton = () => {
      const {
        fontId,
        fontStyles,
        hasValidName
      } = this.props;
      const {
        fontIsSaving,
        fontSaveFailed
      } = this.state;
      const assignedStyles = fontStyles && fontStyles.filter(style => style.fileName && style.style);
      const pageIsReadyForNext = hasValidName && fontStyles && assignedStyles && assignedStyles.length === fontStyles.length;
      return /*#__PURE__*/_jsx(UITooltip, {
        placement: "right",
        disabled: !!pageIsReadyForNext,
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey('pagination.disabledTooltip')
        }),
        children: /*#__PURE__*/_jsx(UILoadingButton, {
          use: "primary",
          disabled: !pageIsReadyForNext,
          onClick: () => this.onSaveFont(),
          loading: fontIsSaving,
          failed: fontSaveFailed,
          "data-selenium": "font-upload-edit-next-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`pagination.${fontId ? 'save' : 'next'}`)
          })
        })
      });
    };
    this.renderSecondaryButton = () => {
      const {
        fontId,
        changePage
      } = this.props;
      return /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: () => changePage(fontId ? ModalPages.MANAGE : ModalPages.ADD),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`pagination.${fontId ? 'cancel' : 'back'}`)
        })
      });
    };
    this.renderName = () => {
      const {
        fontName
      } = this.props;
      const {
        editingName
      } = this.state;
      return editingName ? /*#__PURE__*/_jsx(UITextInput, {
        name: "font-name",
        placeholder: text(i18nKey('nameLabel')),
        onChange: this.onNameChange,
        value: fontName,
        "data-selenium": `font-upload-edit-name-input`
      }) : /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: fontName
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(UILink, {
            onClick: () => this.setState({
              editingName: true
            }),
            className: "m-top-1 m-left-3",
            "data-selenium": `font-upload-edit-name-button`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(`editNameLink`)
            })
          })
        })]
      });
    };
    this.renderVariantRows = () => {
      const {
        fontStyles,
        removeFile
      } = this.props;
      return fontStyles && fontStyles.map((style, index) => {
        const {
          fileName
        } = style;
        return /*#__PURE__*/_jsx(UIFormControl, {
          label: I18n.text(i18nKey('fontStyle'), {
            index: index + 1
          }),
          children: /*#__PURE__*/_jsxs(UIGrid, {
            children: [/*#__PURE__*/_jsx(UIGridItem, {
              size: 5,
              "data-selenium": `font-upload-edit-style-row:${fileName || 'empty'}`,
              children: /*#__PURE__*/_jsx(UISelect, {
                options: this.fontStyleOptions,
                placeholder: I18n.text(i18nKey('selectStyle')),
                onChange: e => this.onStylesChange(index, e.target.value),
                value: style.style,
                "data-selenium": `font-upload-edit-style-select:${fileName || 'empty'}`
              })
            }), /*#__PURE__*/_jsx(UIGridItem, {
              size: 6,
              children: this.renderFile(style, index)
            }), /*#__PURE__*/_jsx(UIGridItem, {
              size: 1,
              className: "align-center",
              children: /*#__PURE__*/_jsx(UIIconButton, {
                use: "transparent",
                onClick: () => removeFile(index, fileName, true),
                "data-selenium": `font-upload-edit-delete-style-button:${fileName || 'empty'}`,
                children: /*#__PURE__*/_jsx(UIIcon, {
                  name: "delete",
                  size: 22,
                  color: FLINT
                })
              })
            })]
          })
        }, fileName || `empty${index + 1}`);
      });
    };
    this.fontStyleMap = FONT_STYLE_OPTIONS.reduce((hash, styleKey) => {
      return Object.assign({}, hash, {
        [text(i18nKey(`styleOptions.${styleKey.replace('-', '')}`))]: styleKey
      });
    }, {});
    this.state = {};
  }
  componentDidMount() {
    const {
      clearUpdateRequestStatuses,
      fetchCustomFont,
      fontFiles,
      fontId,
      fontStyles,
      handleUpdate
    } = this.props;
    clearUpdateRequestStatuses();

    //if ID then editing an existing font
    //if not just assigning styles for newly added font
    if (fontId) {
      fetchCustomFont(fontId);
    } else {
      //if adding new font and no styles added yet, initialize styles for each file
      const initFontStyles = fontFiles && fontFiles.map(file => {
        const initStyle = fontStyles && fontStyles.find(style => style.fileName === file.fileName);
        return {
          fileName: file.fileName,
          style: initStyle && initStyle.style
        };
      });
      handleUpdate({
        fontStyles: initFontStyles
      });
    }
  }
  get fontStyleOptions() {
    const stylesReadable = Object.keys(this.fontStyleMap);
    return stylesReadable.map(style => ({
      value: style
    }));
  }

  //TODO refactor some of this logic into helpers to minimize size in the update function
  componentDidUpdate(prevProps) {
    const {
      createCustomFont,
      createCustomFontRequestStatus,
      customFontFetchStatus,
      editCustomFont,
      editCustomFontRequestStatus,
      fetchCustomFontFileRequestStatus,
      fetchFile,
      fontFiles,
      fontFilesUploaded,
      fontId,
      fontToEdit,
      handleUpdate,
      uploadedFileManagerFilesById,
      uploadedFileManagerFilesByName,
      uploadFileRequestStatus,
      usageTracker
    } = this.props;
    const {
      customFontFetchStatus: prevCustomFontFetchStatus,
      editCustomFontRequestStatus: prevEditCustomFontRequestStatus,
      createCustomFontRequestStatus: prevCreateCustomFontRequestStatus,
      fontFiles: prevFontFiles,
      fetchCustomFontFileRequestStatus: prevFetchCustomFontFileRequestStatus
    } = prevProps;

    //if editing font, handle existing font data after fetch
    if (prevCustomFontFetchStatus === RequestStatus.PENDING && customFontFetchStatus === RequestStatus.SUCCEEDED && fontToEdit && fontToEdit.id === fontId) {
      const unpackagedFontData = this.unpackageBrandingCustomFontData(fontToEdit);
      handleUpdate(unpackagedFontData);
    }

    //fetch file data after files are unpackaged
    if (!prevFontFiles && fontFiles && fontFiles.length) {
      fontFiles.forEach(file => {
        fetchFile(file.fileId, file.fileName);
      });
    }

    //update fontFiles with fetched file data
    if (fontFiles && fontFiles.length === Object.keys(fetchCustomFontFileRequestStatus).length) {
      //check that files fetched successfully
      const fileNotFetched = Object.keys(fetchCustomFontFileRequestStatus).find(id => fetchCustomFontFileRequestStatus[id] !== RequestStatus.SUCCEEDED);
      const prevFileNotFetched = Object.keys(prevFetchCustomFontFileRequestStatus).find(id => prevFetchCustomFontFileRequestStatus[id] !== RequestStatus.SUCCEEDED);
      if (!fileNotFetched && prevFileNotFetched) {
        const updatedFontFiles = fontFiles.map(file => {
          const fileManagerFile = uploadedFileManagerFilesById[file.fileId];
          return Object.assign({}, file, {
            fileSize: fileManagerFile.size
          });
        });
        handleUpdate({
          fontFiles: updatedFontFiles
        });
      }
    }

    //if uploading files, save font after uploads finish
    const readyToEdit = fontId && editCustomFontRequestStatus === (RequestStatus.UNINITIALIZED || RequestStatus.FAILED);
    const readyToCreate = !fontId && createCustomFontRequestStatus === (RequestStatus.UNINITIALIZED || RequestStatus.FAILED);
    if (fontFilesUploaded && fontFilesUploaded.length === Object.keys(uploadFileRequestStatus).length && (readyToEdit || readyToCreate)) {
      //check that files uploaded successfully
      const fileNotUploadedStatus = Object.values(uploadFileRequestStatus).find(status => status !== RequestStatus.SUCCEEDED);
      if (!fileNotUploadedStatus) {
        //add file manager urls to file objects
        const updatedFontFiles = fontFiles.map(file => {
          const fileManagerFile = uploadedFileManagerFilesByName[file.fileName];
          return fileManagerFile && Object.assign({}, file, {
            file: fileManagerFile.url,
            fileId: fileManagerFile.id,
            format: fileManagerFile.extension
          });
        });

        //now save the font
        if (readyToEdit) {
          editCustomFont(this.packageBrandingCustomFontData(updatedFontFiles));
          usageTracker.track('ContentComponentsInteraction', {
            action: 'custom-fonts-create-font'
          });
        }
        if (readyToCreate) {
          createCustomFont(this.packageBrandingCustomFontData(updatedFontFiles));
          usageTracker.track('ContentComponentsInteraction', {
            action: 'custom-fonts-create-font'
          });
        }
      } else if (fileNotUploadedStatus === RequestStatus.FAILED) {
        handleUpdate({
          errorMessage: i18nKey('error.fileUploadFail')
        });
        this.setState({
          fontIsSaving: false,
          fontSaveFailed: true
        });
      }
    }

    //if font saved, go to manage page
    if (fontId && editCustomFontRequestStatus !== RequestStatus.PENDING && prevEditCustomFontRequestStatus === RequestStatus.PENDING || !fontId && createCustomFontRequestStatus !== RequestStatus.PENDING && prevCreateCustomFontRequestStatus === RequestStatus.PENDING) {
      if (fontId && editCustomFontRequestStatus === RequestStatus.SUCCEEDED || !fontId && createCustomFontRequestStatus === RequestStatus.SUCCEEDED) {
        handleUpdate({
          page: ModalPages.MANAGE,
          fontName: undefined,
          fontFiles: undefined,
          fontFilesUploaded: undefined,
          fontStyles: undefined,
          fontAdded: !fontId
        });
      } else {
        handleUpdate({
          errorMessage: i18nKey('error.fontSaveFailGeneric')
        });
        this.setState({
          fontIsSaving: false,
          fontSaveFailed: true
        });
      }
    }
  }
  packageBrandingCustomFontData(updatedFontFiles) {
    const {
      fontName,
      fontId,
      fontFiles = [],
      fontStyles
    } = this.props;
    const files = updatedFontFiles || fontFiles;
    const variants = files.reduce((hash, file) => {
      const stylePair = fontStyles && fontStyles.find(style => style.fileName === file.fileName);
      const variantName = stylePair && stylePair.style;
      if (variantName) {
        const existingVariantIndex = hash.findIndex(variant => variant.name === variantName);
        if (existingVariantIndex !== -1) {
          const existingVariant = hash[existingVariantIndex];
          hash[existingVariantIndex] = Object.assign({}, existingVariant, {
            files: [...existingVariant.files, file]
          });
        } else {
          hash.push({
            files: [file],
            name: variantName,
            style: this.createStyleCSSString(variantName)
          });
        }
      }
      return hash;
    }, []);
    return Object.assign({
      name: fontName,
      variants
    }, fontId ? {
      id: fontId
    } : {});
  }
  createStyleCSSString(styleValue) {
    const styleKey = this.fontStyleMap[styleValue];
    const styleParsed = styleKey.split('-');
    const isItalic = styleParsed[1] && styleParsed[1] === 'italic';
    const style = `{"font-weight":${styleParsed[0]}${isItalic ? ', "font-style":"italic"' : ''}}`;
    return style;
  }
  render() {
    const {
      fontId,
      fontToEdit,
      customFontFetchStatus,
      handleUpdate
    } = this.props;
    if (fontId && !fontToEdit) {
      if (customFontFetchStatus === (RequestStatus.UNINITIALIZED && RequestStatus.PENDING)) {
        return /*#__PURE__*/_jsx(UILoadingSpinner, {
          layout: "centered",
          className: "m-bottom-10"
        });
      }
      if (customFontFetchStatus === RequestStatus.FAILED) {
        handleUpdate({
          errorMessage: i18nKey('error.fontEditFetchFail')
        });
      }
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [(!fontId || fontId && fontToEdit) && /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: i18nKey('body')
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(UILink, {
            href: "https://knowledge.hubspot.com/website-pages/use-fonts-in-hubspot#use-custom-fonts",
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('linkLearnMore')
            })
          })
        }), this.renderName(), this.renderVariantRows(), /*#__PURE__*/_jsxs(UIButton, {
          className: "m-top-5",
          use: "transparent",
          onClick: () => this.addEmptyStyle(),
          "data-selenium": "font-upload-edit-add-style-button",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "add"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('addMoreFiles')
          })]
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [this.renderPrimaryButton(), this.renderSecondaryButton()]
      })]
    });
  }
}
export default connector(EditCustomFont);